import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const CustomSlider = ({
  min = 0,
  max = 1000000000,
  step = 50000000,
  value,
  onChange,
  marks,
  ...props
}) => {
  return (
    <div className="w-full px-2 pt-4 pb-12">
      <Slider
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onChange}
        marks={marks}
        styles={{
          rail: { backgroundColor: '#bfdbfe', height: 8 }, // blue-200
          track: { backgroundColor: '#3b82f6', height: 8 }, // blue-400
          handle: {
            borderColor: '#2563eb',
            height: 20,
            width: 20,
            marginTop: -8,
            backgroundColor: '#fff',
          },
        }}
        {...props}
      />
    </div>
  );
};

export default CustomSlider;
